/**
 * Team & Staff Constants
 * Shared constants for team and staff management
 */

// Staff roles
export const STAFF_ROLES = [
  { value: "manager", label: "Team Manager", permissions: "limited" },
  { value: "assistant_coach", label: "Assistant Coach", permissions: "limited" },
  { value: "volunteer", label: "Volunteer", permissions: "view_only" },
  { value: "admin_assistant", label: "Admin Assistant", permissions: "limited" }
];

// Board positions with icons
export const BOARD_POSITIONS = [
  { value: "president", label: "President" },
  { value: "vice_president", label: "Vice President" },
  { value: "secretary", label: "Secretary" },
  { value: "treasurer", label: "Treasurer" },
  { value: "director", label: "Director" },
  { value: "member_at_large", label: "Member at Large" },
  { value: "advisor", label: "Advisor" },
  { value: "other", label: "Other" }
];

// Board permission options
export const BOARD_PERMISSIONS = [
  { key: "view_financials", label: "View Financials", description: "View financial reports and transactions" },
  { key: "view_registrations", label: "View Registrations", description: "View player registrations" },
  { key: "view_programs", label: "View Programs", description: "View program details and rosters" },
  { key: "approve_coaches", label: "Approve Coaches", description: "Review and approve coach applications" },
  { key: "manage_staff", label: "Manage Staff", description: "Add and manage staff members" },
  { key: "manage_settings", label: "Manage Settings", description: "Modify organization settings" },
  { key: "full_admin", label: "Full Admin Access", description: "Complete administrative access" }
];
